import { Outlet, useLocation, useNavigate, useParams } from 'react-router';
import {
    bodyContainerStyle,
    bodyStyle,
    fillerStyle,
    navButtonContainerStyle,
    navButtonStyle,
    navButtonTextContainerStyle,
    navButtonTextStyle
} from './data-request-form.styles';
import { useFormContext, useFormState } from 'react-hook-form';
import { DTITab } from '@vivli/shared/infrastructure/constants';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';

interface DataRequestFormRoutesComponentProps {
    routes: { route: string; title: string }[];
    handleFormSave: () => void;
}

export const DataRequestFormRoutesComponent = ({ routes, handleFormSave }: DataRequestFormRoutesComponentProps) => {
    const { dataRequest } = useDataRequestContext();
    const navigate = useNavigate();
    const location = useLocation();
    const { status } = useParams();

    const { control } = useFormContext<IDataRequest>();
    const { errors } = useFormState({ control });
    const isResearchTeamValid = !errors.researchTeam;

    const isActive = (route: string) => {
        return location.pathname.includes(route);
    };

    return (
        <div style={bodyContainerStyle}>
            <div style={navButtonContainerStyle}>
                {routes.map(({ route, title }) => (
                    <div
                        key={route}
                        style={navButtonStyle(isActive(route))}
                        onClick={() => {
                            navigate(`../${status ? `${status}/` : ''}${dataRequest.id}/${route}`, { replace: true });
                            handleFormSave();
                        }}
                        data-test-id={DTITab.DataRequestTabs(title.replace(/\s/g, ''))}
                    >
                        <div style={navButtonTextContainerStyle}>
                            <span style={navButtonTextStyle(isActive(route))}>
                                {title}
                                {title == 'Research Team' && !isResearchTeamValid && ' ❗'}
                            </span>
                        </div>
                    </div>
                ))}

                <div style={fillerStyle} />
            </div>

            <div style={bodyStyle} className="scrolly">
                <div style={{ flex: 'auto' }}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};
